import { InternalAxiosRequestConfig } from 'axios';

export const bearerTokenInterceptor = async (config: InternalAxiosRequestConfig) => {
  if (process.env.NODE_ENV === 'test' || config.skipAuthInterceptor) {
    return config;
  }

  // MSAL is loaded on the first authenticated request: a static import pulls it into every module (and test)
  // using the API client
  const { authRequestForSilentAndPopupFlows, msalInstance } = await import(
    '@shared/providers/AzureAuthProvider/authConfig'
  );
  const account = msalInstance.getActiveAccount();

  if (!account) {
    throw Error('No active account! Verify a user has been signed in and setActiveAccount has been called.');
  }

  const response = await msalInstance.acquireTokenSilent({
    ...authRequestForSilentAndPopupFlows,
    account: account,
  });

  const accessToken = response.accessToken;

  if (config.headers) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }

  return config;
};
